// extracted by mini-css-extract-plugin
module.exports = {"Content":"Content_Content__2Kj17"};